import { render, staticRenderFns } from "./UMLPropertyPanel.vue?vue&type=template&id=ff59cf8a&"
import script from "./UMLPropertyPanel.vue?vue&type=script&lang=js&"
export * from "./UMLPropertyPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports